<template>
  <v-tooltip
    :theme="theme"
    :triggers="hasContent ? triggers : []"
    :placement="placement"
    :boundary="boundary"
    :auto-hide="autoHide"
    class="d-inline-block"
    :popper-class="popperClass"
    :target-classes="targetClasses"
    :class="classes"
    :shown="shown"
    @hide="onTooltipHide"
    @show="onTooltipShow"
  >
    <span>
      <slot></slot>
    </span>
    <template #popper="{ hide }">
      <slot name="tooltip" :hide="hide">
        <div class="order-status-tooltip" v-html="content" ref="tooltipContent" tabindex="0"></div>
      </slot>
    </template>
  </v-tooltip>
</template>

<script>
import { computed, ref } from 'vue'

export default {
  name: 'Tooltip',
  // #region - Props
  props: {
    content: {
      type: String
    },
    theme: {
      type: String,
      default: 'tooltip'
    },
    triggers: {
      type: Array,
      default: ['hover', 'click']
    },
    placement: {
      type: String,
      default: 'top'
    },
    boundary: {
      type: String,
      default: 'body'
    },
    autoHide: {
      type: Boolean,
      default: true
    },
    classes: {
      type: Array
    },
    popperClass: {
      type: Array
    },
    targetClasses: {
      type: Array
    },
    shown: {
      type: Boolean
    }
  },
  // endregion
  setup(props, { slots }) {
    const hasContent = computed(() => !!props.content || !!slots.tooltip)
    const tooltipContent = ref(null)

    const onTooltipHide = () => {
      if (tooltipContent.value) {
        tooltipContent.value.setAttribute('inert', 'true')
        tooltipContent.value.setAttribute('aria-hidden', 'false')
      }
    }

    const onTooltipShow = () => {
      if (tooltipContent.value) {
        tooltipContent.value.removeAttribute('inert')
        tooltipContent.value.removeAttribute('aria-hidden')
      }
    }

    return {
      hasContent,
      tooltipContent,
      onTooltipHide,
      onTooltipShow
    }
  }
}
</script>

